<!-- Toast Messages -->
<p-toast data-testid="bpmn-view-toast"></p-toast>

<!-- BPMN View Container -->
<div
  class="bpmn-view-container h-screen flex flex-col overflow-hidden"
  data-testid="bpmn-view-page"
>
  <!-- Header with action buttons -->
  <div
    class="flex justify-between items-center sticky top-0 bg-white z-10 px-6 pt-6 pb-4"
  >
    <h2 class="text-2xl font-semibold text-gray-800">
      {{ "bpmn.view.title" | translate }}
      @if (processData()) {
        <span class="text-lg font-normal text-gray-600 ml-2">
          - {{ processData()?.name }}
        </span>
      }
    </h2>
    <div class="flex gap-3 mt-2">
      <!-- Back Button -->
      <app-button
        [testId]="'bpmn-view-back-btn'"
        [label]="'bpmn.view.actions.back' | translate"
        (emitOnClick)="onBack()"
        [outlined]="true"
        type="secondary"
      ></app-button>
    </div>
  </div>

  <!-- Main content area -->
  <div class="flex-1 min-h-0 flex overflow-hidden">
    <!-- BPMN Designer Area -->
    <div class="flex-1 flex flex-col min-h-0">
      <!-- BPMN Toolbar -->
      <div class="bg-gray-50 p-4">
        <div class="flex items-center justify-between">
          <div class="flex items-center gap-3">
            <!-- Export File Button -->
            <app-button
              [testId]="'bpmn-view-export-file-btn'"
              [label]="'bpmn.view.toolbar.export_file'"
              [icon]="'download'"
              (emitOnClick)="onExportFile()"
              type="secondary"
              [outlined]="true"
            ></app-button>

            <!-- Export Image Button -->
            <app-button
              [testId]="'bpmn-view-export-image-btn'"
              [label]="'bpmn.view.toolbar.export_image'"
              [icon]="'image'"
              (emitOnClick)="onExportImage()"
              type="secondary"
              [outlined]="true"
            ></app-button>
          </div>
        </div>
      </div>

      <!-- BPMN Modeler Container -->
      <div class="flex-1 bg-gray-50 p-4">
        <div
          class="h-full bg-white border border-gray-300 rounded-lg overflow-hidden"
        >
          <!-- BPMN Modeler -->
          <div
            #modelerContainer
            class="w-full h-full relative"
            data-testid="bpmn-view-modeler"
          >
            <!-- Floating Zoom Controls -->
            <div class="absolute bottom-4 right-20 z-10">
              <div
                class="flex items-center gap-1 bg-white/30 border border-gray-300/20 rounded-lg p-1 backdrop-blur-sm"
              >
                <!-- Zoom In Button -->
                <app-button
                  [testId]="'bpmn-view-zoom-in-btn'"
                  [icon]="'zoom_in'"
                  (emitOnClick)="onZoomIn()"
                  type="secondary"
                  [outlined]="true"
                  [title]="'bpmn.view.toolbar.zoom_in' | translate"
                ></app-button>

                <!-- Zoom Out Button -->
                <app-button
                  [testId]="'bpmn-view-zoom-out-btn'"
                  [icon]="'zoom_out'"
                  (emitOnClick)="onZoomOut()"
                  type="secondary"
                  [outlined]="true"
                  [title]="'bpmn.view.toolbar.zoom_out' | translate"
                ></app-button>

                <!-- Divider -->
                <div class="border-l border-gray-300/30 h-6 mx-1"></div>

                <!-- Fit to Viewport Button -->
                <app-button
                  [testId]="'bpmn-view-fit-viewport-btn'"
                  [icon]="'fit_screen'"
                  (emitOnClick)="onFitToViewport()"
                  type="secondary"
                  [outlined]="true"
                  [title]="'bpmn.view.toolbar.fit_viewport' | translate"
                ></app-button>

                <!-- Reset Zoom Button -->
                <app-button
                  [testId]="'bpmn-view-reset-zoom-btn'"
                  [icon]="'zoom_in_map'"
                  (emitOnClick)="onResetZoom()"
                  type="secondary"
                  [outlined]="true"
                  [title]="'bpmn.view.toolbar.zoom_reset' | translate"
                ></app-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Properties Panel -->
    <div class="properties-panel w-80 bg-gray-50 pb-4 pr-2">
      <div
        #propertiesPanelContainer
        data-testid="bpmn-view-properties-panel"
        class="overflow-y-auto bg-gray-50 h-[calc(100%-80px)] mt-[80px] border border-gray-300 rounded-lg"
      ></div>
    </div>
  </div>
</div>
